import { getDashColor } from '../../styles'
import { DASHCOLORS } from 'bd-web-components'
import styled, { css } from 'styled-components'

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: max-content;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: max-content;
  }
`
export const LoaderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px;
  padding-bottom: 16px;
  @media (max-width: 768px) {
  }
`

// ASJIOASKLASJLKASKAKJLSAS

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  padding: 0px 64px;
  height: 100%;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const PageTitle = styled.h4`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-top: 0px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-top: 0px;
    margin-bottom: 5px;
  }
`

export const PageSubtitle = styled.p`
  color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  opacity: 0.6;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 18px;
  }
`

export const TableTag = styled.p`
  margin-top: 10px;
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 12px;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 14.5px;
    margin-bottom: 12px;
  }
`

export const FormDivider = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    margin-top: 29px;
    margin-bottom: 24px;
  }
`
export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`
export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }
`
export const CloseButton = styled.button`
  border: none;
  align-self: center;
  justify-self: center;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`

export const ModalContainerTop = styled.div`
  padding-bottom: 25px;
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid ${DASHCOLORS.GRAY_SCALE_08};
  margin-bottom: 33px;
`

export const ModalContainerBottom = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: space-between;
  justify-content: space-between;
`

export const Space = styled.div`
  width: 10px;
`

export const ModalTitle = styled.h5`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.6px;
  }
`

export const ModalSubText = styled.p`
  color: ${DASHCOLORS.GRAY_SCALE_05};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const FinancialClosingButtons = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 8px;
  padding: 16px 0px;

  &.block {
    display: block;

    button {
      width: 100%;
      margin-bottom: 10px;
    }
  }
`

export const Button = styled.button`
  padding: 10px 35px;
  border: 1px solid ${DASHCOLORS.SECONDARY_ORANGE_01};
  background-color: ${DASHCOLORS.SECONDARY_ORANGE_01};
  color: ${DASHCOLORS.WHITE};
  border-radius: 8px;
  font-weight: 600;
  padding: 10px 56px;
  font-size: 12px;
  cursor: pointer;

  &.large {
    font-size: 14px;
    min-height: 45px;
  }

  &.outlined {
    padding: 10px 35px;
    color: ${DASHCOLORS.PRIMARY_BLUE_01};
    background-color: transparent;

    &.default {
      border: 1px solid ${DASHCOLORS.GRAY_SCALE_08};
    }
  }

  &.success {
    color: ${DASHCOLORS.WHITE};
    background-color: ${DASHCOLORS.SECONDARY_GREEN_07};
    border: 1px solid ${DASHCOLORS.SECONDARY_GREEN_07};
  }
`

interface TableContainerProps {
  height: number
  margin: boolean
}

export const ExceptionContainer = styled(styled.div``) <TableContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`
